/**
 * Session timeout configuration
 * Adjust these values based on your security requirements
 */
export const sessionConfig = {
	/**
	 * Session timeout duration in minutes
	 * Recommended values:
	 * - 15-20 minutes for general applications
	 * - 5-15 minutes for security-sensitive applications
	 * - 1-2 hours for user-friendly applications
	 */
	timeoutMinutes: 20,

	/**
	 * Warning time before logout in minutes
	 * How much time before logout should the warning appear
	 */
	warningMinutes: 2,

	/**
	 * Enable/disable session timeout functionality
	 * Set to false to disable session timeout entirely
	 */
	enabled: true,

	/**
	 * Activity throttle time in milliseconds
	 * Prevents excessive timer resets from rapid user activity
	 */
	activityThrottleMs: 1000,

	/**
	 * Events that count as user activity
	 * These DOM events will reset the session timer
	 */
	activityEvents: ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'] as const,
} as const

/**
 * Different timeout configurations for different environments
 */
export const sessionConfigProfiles = {
	development: {
		...sessionConfig,
		timeoutMinutes: 40,
		warningMinutes: 1,
	},

	quality: {
		...sessionConfig,
		timeoutMinutes: 15,
		warningMinutes: 1,
	},

	production: {
		...sessionConfig,
		timeoutMinutes: 15,
		warningMinutes: 1,
	},
} as const

/**
 * Get session configuration based on environment or profile
 */
export const getSessionConfig = (profile?: keyof typeof sessionConfigProfiles) => {
	if (profile && sessionConfigProfiles[profile]) {
		return sessionConfigProfiles[profile]
	}

	// Default to production config or based on NODE_ENV
	const env = process.env.NODE_ENV as keyof typeof sessionConfigProfiles
	return sessionConfigProfiles[env] || sessionConfigProfiles.production
}
